/**
 * Icone de uma letra 'T' 
 * Usado para abrir o menu com as possiveis 
 * figuras que podem ser usadas com a
 * ferramenta 'Inserir Texto'
 */
export const InsertTextIcon = (props) => (
  <svg 
    width="19" 
    height="18" 
    viewBox="0 0 19 18" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path 
      d="M13.0547 0.820312H16.7777C17.33 0.820312 17.7777 1.26803 17.7777 1.82031V5.35055" 
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.4"
    />
    <path 
      d="M13.0547 16.8203H16.7777C17.33 16.8203 17.7777 16.3726 17.7777 15.8203V12.2901" 
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.4"
    />
    <path 
      d="M6.30859 0.820312H2.58558C2.0333 0.820312 1.58558 1.26803 1.58558 1.82031V5.35055" 
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.4"
    />
    <path 
      d="M6.30859 16.8203H2.58558C2.0333 16.8203 1.58558 16.3726 1.58558 15.8203V12.2901" 
      stroke={props.stroke || 'currentColor'}
      strokeWidth="1.4"
    />
    <path 
      d="M5.26562 3.72656V5.76625H8.6651V13.925H10.7048V5.76625H14.1043V3.72656H5.26562Z" 
      fill={props.fill || 'currentColor'}
    />
  </svg>
);

/**
 * Icone de lixeira
 * usado para excluir desenhos feitos
 */
export const TrashIcon = (props) => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.94025 1.64773H4.31525V1.27273C4.31525 0.776926 4.71718 0.375 5.21298 0.375H7.75843C8.25424 0.375 8.65616 0.776926 8.65616 1.27273V1.64773H9.03116H12.213C12.3573 1.64773 12.4743 1.76474 12.4743 1.90909V3.18182C12.4743 3.32617 12.3573 3.44318 12.213 3.44318H11.5766H11.2016V3.81818V12.7273C11.2016 13.2231 10.7997 13.625 10.3039 13.625H2.66752C2.17172 13.625 1.7698 13.2231 1.7698 12.7273V3.81818V3.44318H1.3948H0.758434C0.614087 3.44318 0.49707 3.32617 0.49707 3.18182V1.90909C0.49707 1.76474 0.614087 1.64773 0.758434 1.64773H3.94025ZM4.57662 4.71591C4.01805 4.71591 3.56525 5.16871 3.56525 5.72727V10.8182C3.56525 11.3767 4.01806 11.8295 4.57662 11.8295C5.13518 11.8295 5.58798 11.3767 5.58798 10.8182V5.72727C5.58798 5.16871 5.13518 4.71591 4.57662 4.71591ZM8.3948 4.71591C7.83624 4.71591 7.38343 5.16871 7.38343 5.72727V10.8182C7.38343 11.3767 7.83624 11.8295 8.3948 11.8295C8.95336 11.8295 9.40616 11.3767 9.40616 10.8182V5.72727C9.40616 5.16871 8.95336 4.71591 8.3948 4.71591Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="0.75"
    />
  </svg>
);

/**
 * Icone de confirmação(check)
 * usado para salvar os desenhos feitos
 */
export const CheckIcon = (props) => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.23235 13.7998C5.91317 13.7998 5.60601 13.6733 5.37926 13.4466L0.554485 8.62179C0.0834008 8.15042 0.0834008 7.38697 0.554485 6.91589C1.02585 6.4448 1.7893 6.4448 2.26039 6.91589L6.1617 10.8172L14.341 1.22322C14.7733 0.716954 15.5342 0.6558 16.0416 1.08779C16.5485 1.52006 16.609 2.28156 16.1771 2.78839L7.15022 13.3759C6.93185 13.632 6.61659 13.7853 6.2801 13.7987C6.26418 13.7992 6.24827 13.7998 6.23235 13.7998Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
